import {
  DSR_EMITTER_EVENT,
  DRS_CLEAR_FILES,
} from "Pages/DRS/Constant/Constant";
import { useDRSContext } from "Pages/DRS/Context/DRSContext";
import DRSFooter from "Pages/DRS/DRSFooter";
import DRSHeader from "Pages/DRS/DRSHeader";
import DRSTabs from "Pages/DRS/DRSTabs";
import { drsEmitter } from "Pages/MyBatches/EmitterBus";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import type { FormProps } from "antd";
import { Form } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import {
  BASE_URL,
  GET_QUESTION_DETAIL,
  SAVE_SOLUTION,
  VIEW_QUESTION,
} from "utilFunctions/Constants/urlConstants";
import { putPostRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import WarningModal from "Components/CommonComponents/WarningModal";
import { CheckCircleOutlined } from "@ant-design/icons";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
const MyBucket = React.lazy(
  () => import("Pages/DRS/DRSTabs/MyBucket/MyBucket")
);
type FieldType = {
  username?: string;
  password?: string;
  remember?: string;
};
const StyledCard = styled<any>("div")`
  border-radius: 8px;
  padding: ${(props: any) =>
    !["xs", "sm", "md"].includes(props.screen) ? "16px" : "10px 0px 40px 0px"};
  height: ${(props: any) =>
    ["xs", "sm", "md"].includes(props.screen) ? "calc(100vh - 150px)" : ""};
  overflow: ${(props: any) =>
    ["xs", "sm", "md"].includes(props.screen) ? "auto" : ""};
  overflow-x: ${(props: any) =>
    ["xs", "sm", "md"].includes(props.screen) ? "hidden" : ""};
`;
const DRSMain = () => {
  const { screen }: any = useWindowSize();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const {
    isQuestionSessionStarted,
    questionPayload,
    fetchQuestionDetail,
    selectedQuestion,
    setIsSubmitDone,
    fetchViewQuestion,
    aiSolutionUsed,
    form,
    DSRFilters,
  } = useDRSContext();
  const [visible, setVisible] = useState(false);
  const [tabIndex, setTabIndex] = React.useState(0);
  const [isCompleted, setIsCompleted] = useState<boolean>(false);
  const isViewMode = location.state?.mode === "view";
  console.log(isViewMode, "isViewModeisViewMode");
  useEffect(() => {
    if (
      pathname.includes("/DRS/states") ||
      pathname.includes("/DRS/regions") ||
      pathname.includes("/DRS/branches") ||
      pathname.includes("/DRS/faculties") ||
      pathname.includes("/DRS/faculty")
    ) {
      setTabIndex(1);
    }
  }, [pathname]);
  const pickQuestion = () => {
    let newURL = BASE_URL + GET_QUESTION_DETAIL + "?";
    const filters2: any = [];
    const formFilters = { ...DSRFilters };
    delete formFilters["dateRange"];
    const formValues: any = removeEmptyFields(formFilters);
    for (const key in formValues) {
      if (Object.prototype.hasOwnProperty.call(formValues, key)) {
        if (formValues[key] != null && formValues[key] != "") {
          filters2.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(formValues[key])
          );
        }
      }
    }
    if (Array.isArray(filters2) && filters2.length > 0) {
      newURL = newURL + "&" + filters2.join("&");
    }
    fetchQuestionDetail(newURL);
  };
  const navigateToQuestion = (id: string) => {
    navigate("/admin/DRS/question/" + id, {
      state: { from: "DRSMain" },
    });
  };
  useEffect(() => {
    if (selectedQuestion?.id) {
      navigateToQuestion(selectedQuestion?.id);
    }
  }, [selectedQuestion]);
  const onSave = () => {
    drsEmitter.emit(DSR_EMITTER_EVENT, {
      tabIndex,
    });
    if (isQuestionSessionStarted) return;
    // toggleQuestionSession();
    pickQuestion();
    return;
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    document.body.classList.add("noOverflow");
    return () => {
      document.body.classList.remove("noOverflow");
    };
  }, []);
  useEffect(() => {
    if (isCompleted) {
      setTimeout(() => {
        setVisible(false);
        setIsCompleted(false);
      }, 3000);
    }
  }, [isCompleted]);
  const onFinish: FormProps<any>["onFinish"] = (values) => {
    console.log("Success:", values, questionPayload);
    if (!isQuestionSessionStarted) return;
    const payload = {
      id: selectedQuestion?.id,
      subjectId: values?.subjectId || null,
      streamId: values?.streamId || null,
      answerText: values?.answerText || null,
      isAnswerFinal: values?.answerText ? true : false,
      aiSolutionUsed: aiSolutionUsed || false,
      attachments: questionPayload?.contentRecordIds,
    };
    putPostRequest({
      url: BASE_URL + SAVE_SOLUTION,
      success: (res: any) => {
        const { data: dataRes } = res || {};
        const { detailMessage } = dataRes || {};
        console.log("data===", detailMessage);
        setIsSubmitDone(true);
        fetchViewQuestion(BASE_URL + VIEW_QUESTION + selectedQuestion.id);
        setVisible(true);
        setIsCompleted(true);
        drsEmitter.emit(DRS_CLEAR_FILES);
      },
      failure: (err: any) => {
        console.log(err);
      },
      body: payload,
      method: "put",
    } as any);
  };

  const onFinishFailed: FormProps<FieldType>["onFinishFailed"] = (
    errorInfo
  ) => {
    console.log("Failed:", errorInfo);
  };
  const { streamId, subjectId } = selectedQuestion || {};
  const streamIdChanged = Form.useWatch("streamId", form);
  const subjectIdChanged = Form.useWatch("subjectId", form);
  const isStreamSubjChanged =
    Boolean(streamIdChanged != streamId) ||
    Boolean(subjectIdChanged != subjectId);
  return (
    <div
      className={
        !["xs", "sm", "md"].includes(screen)
          ? "batchTableContainer pt-0 pb-1 mt-2"
          : "ml-0 mr-0"
      }
    >
      <WarningModal
        visible={visible}
        setVisible={setVisible}
        warningMessage={
          isStreamSubjChanged
            ? "Doubt has been moved to the correct subject and stream"
            : "Successfully saved"
        }
        iconComponent={
          <CheckCircleOutlined
            style={{ fontSize: 48, color: "green", marginBottom: 16 }}
          />
        }
      ></WarningModal>
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 24 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        form={form}
      >
        <StyledCard screen={screen}>
          {isQuestionSessionStarted ? (
            <div>
              {!["xs", "sm", "md"].includes(screen) && (
                <DRSHeader tabIndex={tabIndex} setTabIndex={setTabIndex} />
              )}
              <MyBucket></MyBucket>
            </div>
          ) : (
            <>
              {!["xs", "sm", "md"].includes(screen) && (
                <DRSHeader tabIndex={tabIndex} setTabIndex={setTabIndex} />
              )}
              <DRSTabs tabIndex={tabIndex} setTabIndex={setTabIndex} />
            </>
          )}
        </StyledCard>
        {isViewMode ? null : <DRSFooter onSave={onSave} tabIndex={tabIndex} />}
      </Form>
    </div>
  );
};

export default DRSMain;
